// react
import DatePicker, { registerLocale } from 'react-datepicker';

import { da } from 'date-fns/locale/da';
// Shared DatePicker utilities and constants
import { DateTime } from 'luxon';

// Register Danish locale
registerLocale('da', da);

// Timezone constant
export const ZONE = 'Europe/Copenhagen';

// Format date to Danish format
export const formatDate = (date) => {
  if (!date) return '';
  const day = date.setLocale('da').toFormat('d.');
  const month = date.setLocale('da').toFormat('MMMM');
  const year = date.setLocale('da').toFormat('yyyy');
  return `${day} ${month} ${year}`;
};

// Normalize date range to timezone
export const normalizeRangeToZone = (range) => {
  if (!range) return [null, null];
  const [start, end] = range;
  return [start ? start.setZone(ZONE) : null, end ? end.setZone(ZONE) : null];
};

// Shortcut items for date selection
export const shortcutsItems = [
  {
    label: '2026',
    getValue: () => {
      const now = DateTime.now().setZone(ZONE);
      return [now.startOf('year'), now];
    },
  },
  {
    label: '2025',
    getValue: () => {
      const now = DateTime.now().setZone(ZONE);
      const lastYearStart = now.minus({ years: 1 }).startOf('year');
      const lastYearEnd = now.minus({ years: 1 }).endOf('year');
      return [lastYearStart, lastYearEnd];
    },
  },
  {
    label: 'Sidste 7 dage',
    getValue: () => {
      const now = DateTime.now().setZone(ZONE);
      return [
        now.minus({ days: 7 }).startOf('day'),
        now.minus({ days: 1 }).endOf('day'),
      ];
    },
  },
  {
    label: 'Sidste 4 uger',
    getValue: () => {
      const now = DateTime.now().setZone(ZONE);
      return [
        now.minus({ weeks: 4 }).startOf('day'),
        now.minus({ days: 1 }).endOf('day'),
      ];
    },
  },
];

// Re-export DatePicker for convenience
export { DatePicker };
